import { useDispatch, useSelector } from "react-redux";
import { setShowAccessKey } from "../features/counter/counterSlice";

export default function useAccessKeyModal() {
  const dispatch = useDispatch();
  const showAccessKey = useSelector((state) => state.counter.showAccessKey);

  const openAccessKeyModal = () => dispatch(setShowAccessKey(true));
  const closeAccessKeyModal = () => dispatch(setShowAccessKey(false));

  return {
    showAccessKey,
    openAccessKeyModal,
    closeAccessKeyModal,
  };
}
